






















































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport } from '@/components'
import { Modal } from '@/components/general'
import { DiscountTypeTableList, DiscountTypeFormCreateEdit } from '@/components/config'

// services
import { DiscountTypesService } from '@/services/config'

// models
import { Paginator } from '@/models'
import { DiscountTypeModel, DiscountTypeForm } from '@/models/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const discountTypeDefault: DiscountTypeForm = {
  name: '',
  is_law: false,
  is_active: true
}

export default defineComponent({
  name: 'DiscountTypeIndex',
  components: {
    PageHeader,
    DiscountTypeTableList,
    Modal,
    DiscountTypeFormCreateEdit,
    ButtonExport
  },
  setup () {
    const showModal = ref(false)
    const title = 'Tipos de Descuento'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Tipo de Descuento'
      }
      return 'Crear Tipo de Decuento'
    })
    const items = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Tipos de Descuentos',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const discountType: Ref<DiscountTypeForm> = ref(discountTypeDefault)
    const allDiscountTypes: Ref<DiscountTypeModel[]> = ref([])
    const getDiscountTypesWithPagination = async () => {
      loading('show')
      const res = await DiscountTypesService.getWithPagination(pagination.value.perPage, pagination.value.currentPage)
      pagination.value = res.pagination
      allDiscountTypes.value = res.objects
      loading('hide')
    }
    getDiscountTypesWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      discountType.value = {
        ...discountTypeDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      discountType.value = {
        ...discountTypeDefault
      }
      idEdit.value = null
      getDiscountTypesWithPagination()
    }
    const editItem = (item: DiscountTypeModel) => {
      discountType.value = {
        name: item.name,
        is_law: item.is_law,
        is_active: item.is_active
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: DiscountTypeModel) => {
      const msg = `Seguro que desea eliminar el Tipo de Descuento: ${item.name}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await DiscountTypesService.delete(item.id)
        alerts.success()
        getDiscountTypesWithPagination()
      }
    }

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getDiscountTypesWithPagination()
    }

    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      pagination.value.currentPage = 1
      getDiscountTypesWithPagination()
    }

    const headersExcel = [
      { text: 'Nombre', value: 'name' },
      { text: 'Status', value: 'status_text' }
    ]

    const itemsExcel = computed(() => {
      return allDiscountTypes.value.map(item => {
        return {
          ...item
        }
      })
    })

    const getAllitems = async () => {
      allDiscountTypes.value = await DiscountTypesService.getAll()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      discountType,
      saveSuccess,
      allDiscountTypes,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems
    }
  }
})
